<template>
  <div
    class="check-container"
    @click.stop
    v-show="closeAll"
    v-loading="loading"
    :element-loading-text="$t('check.正在进入直播间')"
  >

    <div class="check-body" v-show="!showGuide">
      <!-- 检测header -->
      <checkHeader :type="type" :errs="errs" />
      <div class="check-content">
        <!-- 摄像头检测 -->
        <checkCamera class="check-left" v-if="type == 'camera'"></checkCamera>
        <!-- 麦克风检测 -->
        <checkMic v-if="type == 'mic'"></checkMic>
        <!-- 扬声器检测 -->
        <checkSpeaker v-if="type == 'speaker'"></checkSpeaker>
        <checkinfo :type="type" v-if="type" :errs="errs" class="check-right"></checkinfo>
      </div>
      <checkFooter :type="type"></checkFooter>
    </div>
    <div
      class="check-skip pointer"
      @click="skipcheck"
      v-if="type != 'checkres' && !showGuide"
    >
      {{ $t("check.skipcheck") }}
    </div>

    <div class="guide" :class="{'guide2': role==12}" v-if="showGuide">
      <div class="guide_left">
        <div class="guide_left_content">
          <div>
            <div class="round"><img :src="require(`@/svg/mic-sprite0.png`)" width="13px" /></div>
            <div class="icon-more-content"><i class="icon-more"></i></div>
          </div>
          <div>
            <div class="round"> <img :src="require('@/svg/local_video.svg')" width="13px"  /></div>
            <div class="icon-more-content"><i class="icon-more"></i></div>
          </div>
        </div>
      </div>
      <img src="@/assets/images/guide.png" class="guide_img" alt="">
      <div class="guide_top"><span><span class="guide_top_tips">{{ $t('check.麦克风和摄像头') }}</span>{{ $t('check.设备') }}</span>{{ $t('check.按钮移到这里了～') }}</div>
      <div class="guide_bottom" @click="closeGuide">{{ $t('check.我知道了') }}</div>
    </div>
  </div>
</template>

<script>
import checkinfo from "@/components/check/checkinfo";
import checkHeader from "@/components/check/checkHeader";
import checkFooter from "@/components/check/checkFooter";
import checkCamera from "@/components/check/checkCamera";
import checkMic from "@/components/check/checkMic";
import checkSpeaker from "@/components/check/checkSpeaker";
import { device } from "@/utils/global";
export default {
  name: "check",
  components: {
    checkinfo,
    checkHeader,
    checkFooter,
    checkCamera,
    checkMic,
    checkSpeaker,
  },
  data() {
    return {
      type: "camera",
      loading: true,
      errs: [],
      openMic: true,
      openCamera: true,
      closeAll: false,
      showGuide: false
    };
  },
  computed: {
    role() {
      //12:主播 6：嘉宾
      return JSON.parse(sessionStorage.getItem("LoginInfo")).type;
    },
    isCheck() {
      return this.$store.getters.isCheck;
    },
    rtcClient() {
      return this.$store.getters.rtcClient;
    },
    webrtc() {
      let webrtc = null;
      if (
        this.rtcClient &&
        this.rtcClient.RTCRoom &&
        this.rtcClient.RTCRoom.webrtc
      ) {
        webrtc = this.rtcClient.RTCRoom.webrtc;
      }
      return webrtc;
    },
    micDefault(){
      console.log(this.$store.getters.micDefault, "this.$store.getters.micDefault");
      return this.$store.getters.micDefault;
    },
  },
  watch: {
    webrtc(val) {
      if (val && this.isCheck) {
        this.init();
      }
    },
    micDefault: {
      immediate: true,
      handler: function (value) {
        if(value == 2 && this.role == 11){
          this.openMic = false;
          this.openCamera = false;
        }
      },
    },
    isCheck(n) {
      if (n) {
        this.closeAll = true
      } else {
        this.setGuide()
      }
    }
  },
  created() {
    const { isIE } = device();
    if (isIE && !localStorage.getItem("isCheckBrowser")) {
      this.$alert(
        this.$t('check.您的浏览器版本过低'),
        {
          title: this.$t('check.提示'),
          customClass: "tip-alert text-left",
          confirmButtonText: this.$t('check.我知道了'),
        }
      ).finally(() => {
        if (this.webrtc) {
          this.init();
        }
        this.$store.commit("SET_ISCHECK", true);

        localStorage.setItem("isCheckBrowser", 1);
      });
    } else {
      if (this.webrtc) {
        this.init();
      }
      this.$store.commit("SET_ISCHECK", true);
    }
  },
  methods: {
    setGuide() {
      let guide = localStorage.getItem("guide");
      if (guide) return this.closeAll = false
      this.showGuide = true
    },
    closeGuide () {
      localStorage.setItem("guide", 1)
      this.showGuide =false
      this.closeAll = false
    },
    async init() {
      await this.webrtc.createLoaclStream(true, true);
      this.loading = false
    },
    // 检测下一项
    nextCheck(err) {
      err && this.errs.push(err);
      if (this.type == "camera") {
        this.type = "mic";
      } else if (this.type == "mic") {
        this.type = "speaker";
      } else if (this.type == "speaker") {
        this.type = "checkres";
      }
    },
    skipcheck() {
      this.type = null;
      this.$nextTick(() => {
        const statusCamera = this.openCamera ? 'active' : 'inactive';
        this.$store.commit("SET_SELFVIDEOSTATUS", statusCamera);
        const status = this.openMic ? 'active' : 'inactive';

        this.$store.commit("SET_SELFAUDIOSTATUS", status);
        this.$store.commit("SET_ISCHECK", false);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.check-container {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: $bg-color;
  z-index: 11111111;
  margin: auto;
  top: 0;
  .check-body {
    width: 760px;
    height: 480px;
    background-color: $dialog-bg-color;
    left: 50%;
    position: relative;
    transform: translate(-50%, -50%);
    top: 50%;
    border-radius: 8px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
    .check-content {
      position: relative;
      > div {
        width: calc(50% - 1px);
        display: inline-block;
        margin-top: 30px;
        vertical-align: top;
        margin-bottom: 28px;
      }
      .check-left {
        border-right: 1px dashed #343e6c;
      }
      .check-right {
        text-align: left;
        &.end-result {
          width: 216px;
          border-left-color: transparent;
          margin-top: 12px;
        }
      }
    }
  }
  .check-skip {
    position: absolute;
    left: 0px;
    right: 0px;
    top: calc(50% + 250px);
    color: #fff;
    border: 1px solid #fff;
    margin: auto;
    width: 110px;
    height: 36px;
    line-height: 36px;
    border-radius: 4px;
  }
}
.guide {
  position: fixed;
  left: 2px;
  bottom: 10px;
  font-size: 16px;
  color: #fff;
  font-weight: 500;
  .guide_left {
    width: 71px;
    height: 146px;
    border-radius: 5px;
    border: 1px dashed #FFFFFF;
    padding: 6px;
    box-sizing: border-box;
    .guide_left_content {
      width: 100%;
      height: 100%;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      flex-direction: column;
      .icon-more {
        width: 26px;
        height: 11px;
        display: inline-block;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-image: url('../../svg/more_setting.svg');
      }
      .icon-more-content {
        height: 20px;
        position: relative;
      }
      .round {
        width: 32px;
        height: 32px;
        background: rgba(221, 221, 221, 0.1);
        border-radius: 26px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

    }
  }
  .guide_img {
    position: absolute;
    left: 80px;
    bottom: 100px;
    width: 150px;
  }
  .guide_top {
    width: 170px;
    height: 70px;
    border-radius: 5px;
    border: 1px dashed #FFFFFF;
    position: absolute;
    top: -130px;
    left: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .guide_bottom {
    width: 110px;
    height: 40px;
    border-radius: 24px;
    border: 1px solid #FFFFFF;
    position: absolute;
    top: 20px;
    left: 240px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}
.guide2 {
  bottom: 130px;
}
.guide_top_tips {
  color: #3986ee;
}
[data-theme='Orange'] .round {
  background: rgba(221, 221, 221, 0.5)!important;
}
[data-theme='Orange'] .guide_top_tips {

 color: #F89B33!important;
}

</style>
